import React from 'react';
import { Collapse as CollapseM } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

class Collapse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        }
    }

    handleCollapse = () => {
        this.setState({
            expanded: !this.state.expanded
        })
    }

    render() {
        const { children, title } = this.props;

        return (
            <React.Fragment>
                <div style={{ width: '100%', fontSize: 16, cursor: 'pointer' }} onClick={this.handleCollapse}>
                    {this.state.expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}{title}
                    {/* <FontAwesomeIcon size="1x" icon={this.state.expanded ? faAngleUp : faAngleDown} style={{ paddingRight: 15 }} />{title} */}
                </div>
                <CollapseM in={this.state.expanded} timeout="auto" unmountOnExit>
                    {children}
                </CollapseM>
            </React.Fragment>
        )
    }
}

export default Collapse;